import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

const ImageUpload = () => {
  const [data, setData] = useState([]);

  const uploadDefaultImages = async () => {
    if (data.length !== 0) {
      for (const item of data) {
        const filePath = `images/${item.id}.origin`;

        // Check if image already exists
        const { data: existingFile } = await supabase.storage
          .from('images')
          .list('images', { search: `${item.id}.origin` });

        if (existingFile && existingFile.length > 0) {
          console.log("Image already exists. Skip to the next Image", item.id);
          continue;
        }

        console.log("Image doesn't exist. Uploading Image", item.id);
        console.log(item.image_src);

        try {
          const response = await fetch(
            (item.image_src || "").replace("http://", "https://")
          );
          const blob = await response.blob();
          console.log(blob);

          const { error: uploadError } = await supabase.storage
            .from('images')
            .upload(filePath, blob);

          if (uploadError) throw uploadError;

          const { data: { publicUrl } } = supabase.storage
            .from('images')
            .getPublicUrl(filePath);

          console.log("downloadURL", publicUrl);

          // Get current image_url array
          const currentImageUrl = item.image_url || [];
          currentImageUrl[0] = publicUrl;

          const { error: updateError } = await supabase
            .from('form_responses')
            .update({ image_url: currentImageUrl })
            .eq('id', item.id);

          if (updateError) throw updateError;
          console.log("Document successfully updated with imgURL!");
        } catch (error) {
          console.error("Error uploading image:", error);
        }
      }
    }
  };

  const getDataFromSupabase = async () => {
    try {
      const { data, error } = await supabase
        .from('form_responses')
        .select('*');

      if (error) throw error;
      console.log("docs", data);
      setData(data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getDataFromSupabase();
  }, []);

  return (
    <>
      <button onClick={() => uploadDefaultImages()}>
        Upload All the Images
      </button>
    </>
  );
};

export default ImageUpload;
